import React from 'react'

function TechSelectionQuell() {
  return (
    <embed src="\pdfs\D2.5.1.8_IG-Q-SB_Quell-Induktions-Bruestungsgeraet_10.2007-2_kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectionQuell